interface ReploElementData {
  type: string;
  data: Record<string, any>;
}

interface ParsedSegment {
  type: "text" | "chat-token";
  content: string;
  elementData?: ReploElementData;
  id: string;
}

/**
 * Parses a string containing <chat-token> tags and returns segments. Segments is a list of text and chat-token
 * objects and we use that to render the entire message.
 */
export function parseChatTokens(input: string): ParsedSegment[] {
  const segments: ParsedSegment[] = [];
  const reploElementRegex = /<chat-token>(.*?)<\/chat-token>/gs;

  let lastIndex = 0;
  let match = reploElementRegex.exec(input);

  while (match !== null) {
    if (match.index > lastIndex) {
      const textContent = input.slice(lastIndex, match.index);
      if (textContent.trim()) {
        segments.push({
          type: "text",
          content: textContent,
          id: `text-${segments.length}`,
        });
      }
    }

    try {
      const elementContent = match[1];
      const elementData = JSON.parse(
        elementContent ?? "{}",
      ) as ReploElementData;

      segments.push({
        type: "chat-token",
        content: match[0],
        elementData,
        id: `element-${segments.length}`,
      });
    } catch (error) {
      console.warn("Failed to parse chat-token:", {
        error,
      });
      segments.push({
        type: "text",
        content: match[0],
        id: `text-${segments.length}`,
      });
    }

    lastIndex = match.index + match[0].length;
    match = reploElementRegex.exec(input);
  }

  // Add remaining text after the last chat-token
  if (lastIndex < input.length) {
    const textContent = input.slice(lastIndex);
    if (textContent.trim()) {
      segments.push({
        type: "text",
        content: textContent,
        id: `text-${segments.length}`,
      });
    }
  }

  return segments;
}
